import styled from 'styled-components';

import theme from './theme';
import { ISelectionOptions } from './types';

const SelectionOptions = styled.fieldset<ISelectionOptions>`
  border: none;
  border-top: solid 1px ${theme.selectionOptionsSeparatorColor};
  margin: 2rem auto 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
  min-width: 100%;
  max-width: 100%;

  &:first-of-type {
    margin-top: 0;
  }
`;

export default SelectionOptions;
